// extracted by mini-css-extract-plugin
export var cartContainer = "_os-4";
export var gray = "_os-1";
export var itemContainer = "_os-2";
export var itemDetails = "_os-3";
export var strong = "_os-0";